import authDispatcher from '../../auth/action/auth';
import doctorDispatcher from '../action/doctor';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0,
  },
  clinics: [],
  teleConsultStatus: true,
};

const doctorReducer = doctorDispatcher(initialState, {
  [doctorDispatcher.getDataSuccess]: (state, payload) => {
    const data = payload?.data;

    /* `users/filter` can answer 200 with a null body. Keep the previous paging
       instead of replacing it with `{ list: undefined }`, which would wipe
       pageIndex/pageSize and leave the pager stuck. */
    if (!data) return { ...state, list: [] };

    return {
      list: data.list || [],
      paging: {
        ...data,
        list: undefined,
      },
    };
  },
  [authDispatcher.logoutSuccess]: (state) => ({ ...initialState }),
  [doctorDispatcher.getClinicSuccess]: (state, { data }) => ({
    clinics: data,
  }),
  [doctorDispatcher.getTeleConsultStatusSuccess]: (state, { data }) => ({
    teleConsultStatus: data,
  }),
});

export default doctorReducer;
